import type { Room } from 'src/types/search'

export enum PriceType {
  AllIn = 'all_in', // Precio por noche (total + fees) + total con impuestos y fees
  AllInDaily = 'all_in_daily', // Precio por noche (total + fees) + total con impuestos y fees
  Net = 'net', // Precio por noche (neto) + total con impuestos
  Gross = 'gross', // total + total con impuestos
  TrivagoNet = 'trivago_net', // Precio por noche (neto) + total sin impuestos
  NetWithFees = 'net_with_fees', // Precio neto + fees (sin tasas)
  NetWithFeesDaily = 'net_with_fees_daily', // Precio neto + fees (sin tasas) por noche
}

export interface IPriceBase {
  priceType: PriceType
  price: number
  currency: string
  priceOld: number
  prime: boolean
  rooms: Room[]
}

export enum RoomTypes {
  Single = 'single',
  MultiRoom = 'multiroom',
  MultiBooking = 'multibooking',
}
